{
  "tabs": {
    "chat": "ചാറ്റ്",
    "reminders": "ഓർമ്മപ്പെടുത്തലുകൾ",
    "calendar": "കാലണ്ടർ",
    "settings": "സജ്ജീകരണങ്ങൾ"
  },
  "common": {
    "cancel": "റദ്ദാക്കുക",
    "save": "സംരക്ഷിക്കുക",
    "confirm": "സ്ഥിരീകരിക്കുക",
    "delete": "ഇല്ലാതാക്കുക",
    "back": "പിന്‍വാങ്ങുക",
    "close": "അടയ്ക്കുക",
    "edit": "തിരുത്തുക",
    "search": "തിരയുക",
    "all": "എല്ലാം",
    "loading": "ലോഡ് ചെയ്യുന്നു...",
    "error": "എന്തോ പിഴച്ചു",
    "notFound": "കണ്ടെത്തിയില്ല",
    "tryAgain": "ദയവായി വീണ്ടും ശ്രമിക്കുക",
    "retry": "വീണ്ടും ശ്രമിക്കുക",
    "undo": "മടങ്ങി വരിക",
    "pullToRefresh": "പുതുക്കാൻ താഴേക്ക് വലിക്കുക",
    "justNow": "ഇപ്പോൾ"
  },
  "auth": {
    "welcome": "FishMemory-ലേക്ക് സ്വാഗതം",
    "tagline": "നിങ്ങളുടെ WhatsApp ഓർമ്മപ്പെടുത്തൽ സഹായി, ഇനി നിങ്ങളുടെ പോക്കറ്റിൽ.",
    "subtitle": "നിങ്ങളുടെ WhatsApp ഓർമ്മപ്പെടുത്തൽ സഹായി, ഇനി നിങ്ങളുടെ പോക്കറ്റിൽ.",
    "phoneLabel": "നിങ്ങളുടെ WhatsApp നമ്പർ",
    "phoneHint": "WhatsApp വഴി ഒരു സ്ഥിരീകരണ കോഡ് അയയ്ക്കും",
    "invalidPhone": "ദയവായി സാധുവായ ഫോൺ നമ്പർ നൽകുക",
    "continue": "തുടരുക",
    "enterPhone": "നിങ്ങളുടെ WhatsApp നമ്പർ നൽകുക",
    "phonePlaceholder": "ഫോൺ നമ്പർ",
    "sendCode": "കോഡ് അയയ്ക്കുക",
    "verifyTitle": "നിങ്ങളുടെ നമ്പർ സ്ഥിരീകരിക്കുക",
    "otpSentTo": "WhatsApp വഴി {{phone}}-ലേക്ക് 6-അക്കം കോഡ് അയച്ചു",
    "enterFullCode": "ദയവായി എല്ലാ 6 അക്കങ്ങളും നൽകുക",
    "invalidOtp": "അസാധുവായ കോഡ്. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
    "otpFailed": "കോഡ് അയക്കാൻ പരാജയപ്പെട്ടു. വീണ്ടും ശ്രമിക്കുക.",
    "otpResent": "കോഡ് വീണ്ടും അയച്ചു",
    "resendIn": "{{seconds}} സെക്കൻഡിനുള്ളിൽ വീണ്ടും അയയ്ക്കുക",
    "resendCode": "കോഡ് വീണ്ടും അയയ്ക്കുക",
    "enterOtp": "നിങ്ങളുടെ WhatsApp-ലേക്ക് അയച്ച കോഡ് നൽകുക",
    "verify": "സ്ഥിരീകരിക്കുക",
    "resend": "കോഡ് വീണ്ടും അയയ്ക്കുക",
    "wrongNumber": "തെറ്റായ നമ്പർ?",
    "backToPhone": "ഫോൺ നമ്പറിലേക്ക് മടങ്ങുക",
    "editPhone": "ഫോൺ നമ്പർ തിരുത്തുക",
    "error": "പിശക്",
    "setupTitle": "സജ്ജീകരണം തുടങ്ങാം",
    "setupSubtitle": "ഇവ പിന്നീട് സജ്ജീകരണങ്ങളിൽ മാറ്റാം",
    "namePlaceholder": "നിങ്ങളുടെ പേര്",
    "letsGo": "സജ്ജീകരണം പൂർത്തിയാക്കുക",
    "skipForNow": "ഇപ്പോൾ ഒഴിവാക്കുക"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "ഒരു സന്ദേശം ടൈപ്പ് ചെയ്യുക...",
    "inputPlaceholder": "ഒരു സന്ദേശം ടൈപ്പ് ചെയ്യുക...",
    "typing": "FishMemory ടൈപ്പിംഗ് ചെയ്യുന്നു...",
    "online": "ഓൺലൈൻ",
    "connecting": "കണക്ട് ചെയ്യുന്നു...",
    "reconnecting": "പുനഃകണക്ട് ചെയ്യുന്നു...",
    "offline": "ഓഫ്‌ലൈൻ",
    "empty": "സംഭാഷണം തുടങ്ങുക",
    "emptyHint": "ഓർമ്മപ്പെടുത്തലുകൾ സൃഷ്ടിക്കുക, നിങ്ങളുടെ ഷെഡ്യൂൾ പരിശോധിക്കുക, അല്ലെങ്കിൽ സഹായം ചോദിക്കുക.",
    "emptyAction": "ഒരു സാമ്പിൾ ഓർമ്മപ്പെടുത്തൽ അയയ്ക്കുക",
    "actions": "ചാറ്റ് പ്രവർത്തനങ്ങൾ",
    "keep": "സന്ദേശങ്ങൾ സൂക്ഷിക്കുക",
    "clearTitle": "ചാറ്റ് ക്ലിയർ ചെയ്യുക",
    "clearConfirm": "ഈ ഉപകരണത്തിലെ എല്ലാ സന്ദേശങ്ങളും ഇല്ലാതാക്കണോ? ഇത് തിരുത്താനാകില്ല.",
    "clear": "ചാറ്റ് ക്ലിയർ ചെയ്യുക",
    "optionSelected": "തിരഞ്ഞെടുത്തത്: {{label}}",
    "sendingSelection": "അയയ്ക്കുന്നു...",
    "connectionLost": "പുനഃകണക്ട് ചെയ്യുന്നു..."
  },
  "reminders": {
    "title": "എന്റെ ഓർമ്മപ്പെടുത്തലുകൾ",
    "active": "സജീവം",
    "today": "ഇന്ന്",
    "thisWeek": "ഈ ആഴ്ച",
    "history": "ചരിത്രം",
    "items": "ഇനങ്ങൾ",
    "emptyTitle": "ഇനിയും ഓർമ്മപ്പെടുത്തലുകൾ ഇല്ല",
    "emptySubtitle": "ചാറ്റിൽ നിന്ന് ഒന്ന് സൃഷ്ടിക്കൂ, ഇത് ഇവിടെ കാണിക്കും.",
    "emptyAction": "ചാറ്റ് തുറക്കുക",
    "filterActive": "സജീവം",
    "filterToday": "ഇന്ന്",
    "filterWeek": "ഈ ആഴ്ച",
    "filterHistory": "ചരിത്രം",
    "emptyState": "ഇനിയും ഓർമ്മപ്പെടുത്തലുകൾ ഇല്ല. ചാറ്റ് തുടങ്ങൂ!",
    "swipeDone": "പൂർത്തിയായി",
    "swipeSnooze": "സ്നൂസ്",
    "swipeDelete": "ഇല്ലാതാക്കുക",
    "search": "ഓർമ്മപ്പെടുത്തലുകൾ തിരയുക...",
    "upcoming": "വരാനിരിക്കുന്ന",
    "completed": "പൂർത്തിയായി",
    "overdue": "വൈകിയ",
    "tomorrow": "നാളെ",
    "synced": "സിങ്ക് ചെയ്തു {{value}}",
    "swipeHint": "കൂടുതൽ പ്രവർത്തനങ്ങൾക്ക് ഓർമ്മപ്പെടുത്തൽ സ്വൈപ്പ് ചെയ്യുക",
    "noResults": "തിരച്ചിലിന് അനുയോജ്യമായ ഓർമ്മപ്പെടുത്തലുകൾ ഇല്ല",
    "noResultsHint": "മറ്റൊരു കീവർഡ് പരീക്ഷിക്കുക അല്ലെങ്കിൽ തിരച്ചിൽ ക്ലിയർ ചെയ്യുക",
    "deleteAllFailed": "എല്ലാ ഓർമ്മപ്പെടുത്തലുകളും ഇല്ലാതാക്കാൻ പരാജയപ്പെട്ടു"
  },
  "calendar": {
    "title": "കാലണ്ടർ",
    "today": "ഇന്ന്",
    "tomorrow": "നാളെ",
    "completed": "പൂർത്തിയായി",
    "noEvents": "ഒന്നും ഷെഡ്യൂൾ ചെയ്തിട്ടില്ല",
    "noEventsSubtitle": "ഓർമ്മപ്പെടുത്തലുകളും കലണ്ടർ ഇവന്റുകളും കാണാൻ ഒരു തീയതി തിരഞ്ഞെടുക്കുക.",
    "googleEvent": "Google Calendar",
    "legendActive": "സജീവം",
    "legendRecurring": "പുനരാവർത്തന",
    "legendDone": "പൂർത്തിയായി",
    "legendGoogle": "Google",
    "previousMonth": "മുമ്പത്തെ മാസം",
    "nextMonth": "അടുത്ത മാസം",
    "previousYear": "മുമ്പത്തെ വർഷം",
    "nextYear": "അടുത്ത വർഷം",
    "goToToday": "ഇന്നേക്ക് പോകുക",
    "all": "എല്ലാം",
    "active": "സജീവം",
    "done": "പൂർത്തിയായി",
    "paused": "താൽക്കാലികമായി നിർത്തി"
  },
  "settings": {
    "title": "സജ്ജീകരണങ്ങൾ",
    "profile": "പ്രൊഫൈൽ",
    "name": "പ്രദർശന പേര്",
    "enterName": "നിങ്ങളുടെ പേര് നൽകുക",
    "language": "ഭാഷ",
    "uiLanguage": "ആപ്പ് ഭാഷ",
    "uiLanguageHelp": "ഈ ഉപകരണത്തിൽ മാത്രം ആപ്പ് UI, കാലണ്ടർ ലേബലുകൾ, ലേയൗട്ട് ദിശ മാറ്റും.",
    "serverLanguage": "ചാറ്റ് ഭാഷ",
    "serverLanguageHelp": "നിങ്ങളുടെ അക്കൗണ്ടിനുള്ള സെർവർ മറുപടികൾക്കും ഓർമ്മപ്പെടുത്തൽ സന്ദേശങ്ങൾക്കും ഉപയോഗിക്കുന്ന ഭാഷ മാറ്റും.",
    "timezone": "സമയമേഖല",
    "currentTimezone": "നിലവിലെ സമയമേഖല",
    "timezoneHelp": "എല്ലാ ഓർമ്മപ്പെടുത്തലുകളുടെ സമയവും ഈ സമയമേഖലയിലാണ് കാണിക്കുക.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "സമയമേഖല സംരക്ഷിക്കുക",
    "timezoneSaved": "സമയമേഖല അപ്ഡേറ്റ് ചെയ്തു",
    "detect": "കണ്ടെത്തുക",
    "detectFailed": "സമയമേഖല കണ്ടെത്താൻ സാധിച്ചില്ല",
    "autoDetect": "GPS-ൽ നിന്ന് സ്വയം കണ്ടെത്തുക",
    "notifications": "അറിയിപ്പുകൾ",
    "notificationsHelp": "ഫോളോ-അപ്പ് ഓർമ്മപ്പെടുത്തലുകൾ ഓർമ്മപ്പെടുത്തൽ നൽകിയ ശേഷം ആവർത്തിക്കുന്ന അലർട്ടുകൾ നിയന്ത്രിക്കുന്നു. ഉപകരണ-തല അറിയിപ്പ് അനുമതികൾ നിങ്ങളുടെ ഫോൺ സജ്ജീകരണങ്ങളിൽ നിയന്ത്രിക്കപ്പെടുന്നു.",
    "pushEnabled": "പുഷ് അറിയിപ്പുകൾ",
    "autoDoneOnFire": "ഫയർ ചെയ്തപ്പോൾ സ്വയം പൂർത്തിയാക്കുക",
    "autoDoneOnFireDesc": "ഓഫ് ആണെങ്കിൽ, നിങ്ങൾ അത് പൂർത്തിയായി അടയാളപ്പെടുത്തുന്നത് വരെ ഓർമ്മപ്പെടുത്തലുകൾ സജീവമായിരിക്കും.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "കണക്ട് ചെയ്തു",
    "googleDisconnected": "കണക്ട് ചെയ്തിട്ടില്ല",
    "googleConnectedHelp": "പുതിയ ഓർമ്മപ്പെടുത്തലുകൾ നിങ്ങളുടെ കലണ്ടറിലേക്ക് സ്വയം സിങ്ക് ചെയ്യാം.",
    "googleDisconnectedHelp": "ഓർമ്മപ്പെടുത്തലുകളും ഇവന്റുകളും സജ്ജമാക്കാൻ Google Calendar കണക്ട് ചെയ്യുക.",
    "googleConnectFailed": "Google Calendar കണക്ട് ചെയ്യാൻ പരാജയപ്പെട്ടു",
    "connected": "കണക്ട് ചെയ്തു",
    "disconnected": "കണക്ട് ചെയ്തിട്ടില്ല",
    "connect": "കണക്ട് ചെയ്യുക",
    "disconnect": "കണക്ട് ഒഴിവാക്കുക",
    "autoSync": "പുതിയ ഓർമ്മപ്പെടുത്തലുകൾ സ്വയം സിങ്ക് ചെയ്യുക",
    "autosync": "പുതിയ ഓർമ്മപ്പെടുത്തലുകൾ സ്വയം സിങ്ക് ചെയ്യുക",
    "subscription": "സബ്സ്ക്രിപ്ഷൻ",
    "trialUsed": "ട്രയൽ: {{used}}/{{total}} ഉപയോഗിച്ചു",
    "trialStatus": "ട്രയൽ ലഭ്യമാണ്",
    "activeStatus": "സജീവ സബ്സ്ക്രിപ്ഷൻ",
    "expiredStatus": "സബ്സ്ക്രിപ്ഷൻ കാലഹരണപ്പെട്ടു",
    "unsubscribedStatus": "സബ്സ്ക്രൈബ് ചെയ്തിട്ടില്ല",
    "about": "പറ്റി",
    "version": "പതിപ്പ്",
    "logout": "ലോഗ് ഔട്ട്",
    "logoutTitle": "ലോഗ് ഔട്ട്",
    "logoutConfirm": "ലോഗ് ഔട്ട് ചെയ്യാൻ നിങ്ങൾ ഉറപ്പാണോ?",
    "noName": "പേര് സജ്ജമാക്കിയിട്ടില്ല",
    "serverConnection": "സെർവർ കണക്ഷൻ",
    "serverUrl": "സെർവർ URL",
    "serverEdit": "തിരുത്തുക",
    "saveReconnect": "സംരക്ഷിച്ച് പുനഃകണക്ട് ചെയ്യുക",
    "resetDefault": "ഡിഫോൾട്ട് പുനഃസജ്ജീകരിക്കുക",
    "invalidServerUrlTitle": "അസാധുവായ സെർവർ URL",
    "invalidServerUrlMessage": "സാധുവായ http അല്ലെങ്കിൽ https സെർവർ URL നൽകുക, ഉദാ: https://example.com",
    "uiLanguageChangeFailed": "ആപ്പ് ഭാഷ മാറ്റാൻ പരാജയപ്പെട്ടു. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
    "serverLanguageChangeFailed": "ചാറ്റ് ഭാഷ മാറ്റാൻ പരാജയപ്പെട്ടു. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
    "timezoneChangeFailed": "സമയമേഖല മാറ്റാൻ പരാജയപ്പെട്ടു. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
    "autoSyncChangeFailed": "സ്വയം സിങ്ക് അപ്ഡേറ്റ് ചെയ്യാൻ പരാജയപ്പെട്ടു. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
    "nameChangeFailed": "പ്രദർശന പേര് അപ്ഡേറ്റ് ചെയ്യാൻ പരാജയപ്പെട്ടു. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "ഓർമ്മപ്പെടുത്തൽ വിശദാംശങ്ങൾ",
    "editTime": "സമയം തിരുത്തുക",
    "rename": "പേര് മാറ്റുക",
    "snooze": "സ്നൂസ് ചെയ്യുക",
    "snooze15": "15 മിനിറ്റ് സ്നൂസ്",
    "pause": "താൽക്കാലികമായി നിർത്തുക",
    "pauseReminder": "ഓർമ്മപ്പെടുത്തൽ താൽക്കാലികമായി നിർത്തുക",
    "resume": "പുനരാരംഭിക്കുക",
    "resumeReminder": "ഓർമ്മപ്പെടുത്തൽ പുനരാരംഭിക്കുക",
    "skip": "അടുത്തത് ഒഴിവാക്കുക",
    "skipOccurrence": "ഈ സംഭവനം ഒഴിവാക്കുക",
    "syncGoogle": "Google-ലേക്ക് സിങ്ക് ചെയ്യുക",
    "delete": "ഇല്ലാതാക്കുക",
    "deleteTitle": "ഓർമ്മപ്പെടുത്തൽ ഇല്ലാതാക്കുക",
    "deleteConfirm": "ഈ ഓർമ്മപ്പെടുത്തൽ സ്ഥിരമായി ഇല്ലാതാക്കും.",
    "deleteRecurringTitle": "പുനരാവർത്തന ഓർമ്മപ്പെടുത്തൽ ഇല്ലാതാക്കുക",
    "deleteRecurringMessage": "ഈ സംഭവനം ഒഴിവാക്കണോ അല്ലെങ്കിൽ മുഴുവൻ പരമ്പര ഇല്ലാതാക്കണോ?",
    "deleteThisOccurrence": "ഈ സംഭവനം ഒഴിവാക്കുക",
    "deleteEntireSeries": "മുഴുവൻ പരമ്പര ഇല്ലാതാക്കുക",
    "done": "പൂർത്തിയായി",
    "markDone": "പൂർത്തിയായി അടയാളപ്പെടുത്തുക",
    "undo": "പുനഃസ്ഥാപിക്കുക",
    "undoPrompt": "ഇത് വീണ്ടും സജീവമാക്കണോ? ഇപ്പോൾ പുനഃസ്ഥാപിക്കുക.",
    "recurring": "പുനരാവർത്തന",
    "nextRun": "അടുത്ത പ്രവർത്തനം",
    "oneTime": "ഒരിക്കൽ മാത്രം",
    "pending": "കാത്തിരിക്കുന്നു",
    "sent": "അയച്ചു",
    "paused": "താൽക്കാലികമായി നിർത്തി",
    "active": "സജീവം",
    "snoozed": "സ്നൂസ് ചെയ്തു",
    "localTime": "നിങ്ങളുടെ പ്രാദേശിക സമയത്തിൽ കാണിക്കുന്നു",
    "recurrence": "പുനരാവർത്തനം",
    "created": "സൃഷ്ടിച്ചത്",
    "tags": "ടാഗുകൾ",
    "fireCount": "ഫയർ ചെയ്ത തവണകൾ",
    "actions": "പ്രവർത്തനങ്ങൾ",
    "none": "ഒന്നുമില്ല",
    "snoozeFailed": "ഓർമ്മപ്പെടുത്തൽ സ്നൂസ് ചെയ്യാൻ പരാജയപ്പെട്ടു",
    "pauseFailed": "ഓർമ്മപ്പെടുത്തൽ താൽക്കാലികമായി നിർത്താൻ പരാജയപ്പെട്ടു",
    "resumeFailed": "ഓർമ്മപ്പെടുത്തൽ പുനരാരംഭിക്കാൻ പരാജയപ്പെട്ടു",
    "skipFailed": "ഓർമ്മപ്പെടുത്തൽ ഒഴിവാക്കാൻ പരാജയപ്പെട്ടു",
    "doneFailed": "ഓർമ്മപ്പെടുത്തൽ പൂർത്തിയായി അടയാളപ്പെടുത്താൻ പരാജയപ്പെട്ടു",
    "undoFailed": "ഓർമ്മപ്പെടുത്തൽ നില പുനഃസ്ഥാപിക്കാൻ പരാജയപ്പെട്ടു",
    "deleteFailed": "ഓർമ്മപ്പെടുത്തൽ ഇല്ലാതാക്കാൻ പരാജയപ്പെട്ടു",
    "rescheduleTitle": "പുനഃക്രമീകരിക്കണോ?",
    "rescheduleMsg": "ഈ ഓർമ്മപ്പെടുത്തൽ വൈകിയിരിക്കുന്നു. നിങ്ങൾ ഇത് പുനഃക്രമീകരിക്കണോ?",
    "reschedule15": "15 മിനിറ്റിനുള്ളിൽ",
    "reschedule60": "1 മണിക്കൂറിനുള്ളിൽ",
    "keepOverdue": "ഇങ്ങനെ തന്നെ വയ്ക്കുക"
  },
  "onboarding": {
    "slide1Title": "FishMemory-ലേക്ക് സ്വാഗതം",
    "slide1Sub": "നിങ്ങളുടെ വ്യക്തിഗത ഓർമ്മപ്പെടുത്തൽ സഹായി — WhatsApp-ൽ പ്രവർത്തിക്കുന്നതും നിങ്ങളുടെ പോക്കറ്റിനായി നിർമ്മിച്ചതും.",
    "slide2Title": "സഹജമായി ചാറ്റ് ചെയ്യൂ",
    "slide2Sub": "നിങ്ങൾ ചിന്തിക്കുന്ന പോലെ ഓർമ്മപ്പെടുത്തലുകൾ ടൈപ്പ് ചെയ്യൂ: \"നാളെ 3 മണിക്ക് അമ്മയെ വിളിക്കാൻ ഓർമ്മിപ്പിക്കൂ\" — ബാക്കി ഞങ്ങൾ കൈകാര്യം ചെയ്യും.",
    "slide3Title": "ഒന്നും നഷ്ടപ്പെടാതിരിക്കുക",
    "slide3Sub": "സമയോചിത അറിയിപ്പുകൾ ലഭിക്കുക, ടാഗുകൾ ഉപയോഗിച്ച് ക്രമീകരിക്കുക, പ്രധാനപ്പെട്ടവയെ എല്ലാം നിയന്ത്രിക്കുക.",
    "getStarted": "തുടങ്ങൂ",
    "next": "അടുത്തത്",
    "firstReminderTitle": "നിങ്ങളുടെ ആദ്യ ഓർമ്മപ്പെടുത്തൽ സൃഷ്ടിക്കൂ!",
    "firstReminderHint": "ഇങ്ങനെ ടൈപ്പ് ചെയ്യാൻ ശ്രമിക്കുക:",
    "firstReminderExample": "നാളെ രാവിലെ 9 മണിക്ക് വെള്ളം കുടിക്കാൻ ഓർമ്മിപ്പിക്കൂ",
    "gotIt": "അറിയാം!",
    "notifRationaleTitle": "സമയത്ത് അറിയിപ്പ് ലഭിക്കുക",
    "notifRationaleBody": "FishMemory നിങ്ങൾക്ക് സമയത്ത് ഓർമ്മിപ്പിക്കാൻ അറിയിപ്പുകൾ ആവശ്യമാണ്. നിങ്ങൾ സൃഷ്ടിക്കുന്ന ഓർമ്മപ്പെടുത്തലുകൾക്കായുള്ള അലർട്ടുകൾ മാത്രമേ ലഭിക്കൂ.",
    "notifRationaleAllow": "അറിയിപ്പുകൾ അനുവദിക്കുക",
    "notifRationaleLater": "ശേഷം കാണാം",
    "swipeHint": "വേഗം പ്രവർത്തനങ്ങൾക്ക് വലത്തേക്ക് സ്വൈപ്പ് ചെയ്യൂ →",
    "calendarDragHint": "വലിച്ചെറിഞ്ഞ് വിപുലീകരിക്കുക ↕"
  }
}
